// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Caml_format = require("rescript/lib/js/caml_format.js");
var JsxRuntime = require("react/jsx-runtime");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var NumberCondition$ReactHooksTemplate = require("./NumberCondition.res.js");

function NumberConditionForm(props) {
  var updateCondition = props.updateCondition;
  var numberCondition = props.numberCondition;
  var operator = NumberCondition$ReactHooksTemplate.operator(numberCondition);
  var rhs = NumberCondition$ReactHooksTemplate.rhs(numberCondition);
  var rhs$1 = rhs !== undefined ? String(rhs) : "";
  var availableOperators = NumberCondition$ReactHooksTemplate.availableOperators();
  var showRhsField;
  switch (operator) {
    case "is_blank" :
    case "is_not_blank" :
        showRhsField = false;
        break;
    default:
      showRhsField = true;
  }
  var match = NumberCondition$ReactHooksTemplate.answerRange(numberCondition.lhs);
  var min = match[0];
  var rhsOptions = Belt_List.makeBy((match[1] - min | 0) + 1 | 0, (function (i) {
          return i + min | 0;
        }));
  var handleOperatorChange = function ($$event) {
    var selectedOperator = Utils$ReactHooksTemplate.formTargetValue($$event);
    var updatedCondition;
    switch (selectedOperator) {
      case "is_blank" :
      case "is_not_blank" :
          updatedCondition = NumberCondition$ReactHooksTemplate.setRhs(NumberCondition$ReactHooksTemplate.setOperator(numberCondition, selectedOperator), undefined);
          break;
      default:
        updatedCondition = NumberCondition$ReactHooksTemplate.setOperator(numberCondition, selectedOperator);
    }
    Curry._1(updateCondition, {
          TAG: "NumberCondition",
          _0: updatedCondition
        });
  };
  var handleRhsChange = function ($$event) {
    var selectedRhs = Caml_format.int_of_string(Utils$ReactHooksTemplate.formTargetValue($$event));
    var updatedCondition = NumberCondition$ReactHooksTemplate.setRhs(numberCondition, selectedRhs);
    Curry._1(updateCondition, {
          TAG: "NumberCondition",
          _0: updatedCondition
        });
  };
  var tmp;
  if (showRhsField) {
    var match$1 = numberCondition.lhs;
    var tmp$1;
    tmp$1 = match$1.TAG === "Question" ? JsxRuntime.jsx("select", {
            children: $$Array.of_list(Belt_List.map(rhsOptions, (function (x) {
                        return JsxRuntime.jsx("option", {
                                    children: String(x),
                                    className: "text-left bg-white-300 px-2 py-1 hover:bg-gray-300",
                                    value: String(x)
                                  }, String(x));
                      }))),
            className: "h-40-px px-2 py-1 rounded bg-white border border-gray-300\n                      cursor-pointer focus:border-gray-600 text-xs",
            placeholder: "Select Answer",
            value: rhs$1,
            onChange: handleRhsChange
          }) : JsxRuntime.jsx("input", {
            className: "h-40-px px-2 py-1 rounded bg-white border border-gray-300\n                      cursor-pointer focus:border-gray-600 text-xs",
            placeholder: "Type Value",
            type: "number",
            value: rhs$1,
            onChange: handleRhsChange
          });
    tmp = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
                  children: "Answer",
                  className: "h-20-px font-normal text-xs text-aurometalsaurus"
                }),
            tmp$1
          ],
          className: "flex flex-col w-5/12"
        });
  } else {
    tmp = JsxRuntime.jsx(JsxRuntime.Fragment, {});
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: "Condition",
                              className: "h-20-px font-normal text-xs text-aurometalsaurus"
                            }),
                        JsxRuntime.jsx("select", {
                              children: $$Array.of_list(Belt_List.map(availableOperators, (function (operator) {
                                          return JsxRuntime.jsx("option", {
                                                      children: NumberCondition$ReactHooksTemplate.humanizeOperator(operator, numberCondition),
                                                      className: "text-left bg-white-300 px-2 py-1 hover:bg-gray-300",
                                                      value: operator
                                                    }, operator);
                                        }))),
                              className: "h-40-px px-2 py-1 rounded bg-white border border-gray-300\n                   cursor-pointer focus:border-gray-600 text-xs",
                              placeholder: "Select Operator",
                              value: operator,
                              onChange: handleOperatorChange
                            })
                      ],
                      className: "flex flex-col w-7/12"
                    }),
                tmp
              ],
              className: "flex gap-2 w-full"
            });
}

var make = NumberConditionForm;

exports.make = make;
/* react/jsx-runtime Not a pure module */
